import React from 'react';
import { Modal, ModalProps, useMantineTheme } from '@mantine/core';

type CustomModalProps = {
  opened: boolean;
  children: React.ReactNode;
  size?: ModalProps['size'];
  withCloseButton?: boolean;
  centered?: boolean;
  closeOnClickOutside?: boolean;
  closeOnEscape?: boolean;
};

const CustomModal: React.FC<CustomModalProps> = ({
  opened,
  children,
  size = 'xl',
  withCloseButton = false,
  centered = true,
  closeOnClickOutside = false,
  closeOnEscape = false,
}) => {
  const theme = useMantineTheme();

  return (
    <Modal
      opened={opened}
      withCloseButton={withCloseButton}
      centered={centered}
      size={size}
      closeOnClickOutside={closeOnClickOutside}
      closeOnEscape={closeOnEscape}
      onClose={() => {}}
      overlayProps={{
        color: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[2],
        opacity: 0.55,
        blur: 3,
      }}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
